export const keys = Object.freeze({
  signIn: 'signIn',
  // authenticate: 'authenticate',
  deleteSelectedEmployees: "deleteSelectedEmployees",
  deleteEmployeeMaster: "deleteEmployeeMaster",
  saveEmployeeMaster: "saveEmployeeMaster",
  employeeMaster: "employeeMaster",
  getEditEmployeeMaster: 'getEditEmployeeMaster',

  userMaster: "userMaster",
  resetUserAccess: "resetUserAccess",
  getVendorCode: "getVendorCode",
  crewMembers: "crewMembers",
  saveUserMaster: 'saveUserMaster',
  updateUserMaster: 'updateUserMaster',
  getEditUserMaster: 'getEditUserMaster',
  getEditUserByDivision: 'getEditUserByDivision',
  getUserByMapDivision: 'getUserByMapDivision',

  saveUserImage: 'saveUserImage',
  deleteUserImage: 'deleteUserImage',

  areaMaster: "areaMaster",
  cityListByArea: (city) => `cityListByDistrict/${city}`,
  saveAreaMaster: 'saveAreaMaster',
  updateAreaMaster: 'updateAreaMaster',
  deleteAreaMaster: 'deleteAreaMaster',
  getEditAreaMaster: 'getEditAreaMaster',

  allowanceMaster: "allowanceMaster",
  saveAllowanceMaster: 'saveAllowanceMaster',
  updateAllowanceMaster: 'updateAllowanceMaster',
  deleteAllowanceMaster: 'deleteAllowanceMaster',
  getEditAllowanceMaster: 'getEditAllowanceMaster',

  accommodationMaster: "accommodationMaster",
  saveAccommodationMaster: 'saveAccommodationMaster',
  updateAccommodationMaster: 'updateAccommodationMaster',
  deleteAccommodationMaster: 'deleteAccommodationMaster',
  getEditAccommodationMaster: 'getEditAccommodationMaster',

  bankMaster: "bankMaster",
  saveBankMaster: "saveBankMaster",
  updateBankMaster: "updateBankMaster",
  deleteBankMaster: "deleteBankMaster",
  getEditBankMaster: 'getEditBankMaster',

  brandMaster: "brandMaster",
  saveBrandMaster: 'saveBrandMaster',
  updateBrandMaster: 'updateBrandMaster',
  deleteBrandMaster: 'deleteBrandMaster',
  getEditBrandMaster: 'getEditBrandMaster',

  regularClaimRMList: "regularClaimRMList",
  regularClaimDMList: "regularClaimDMList",
  regularClaimHRList: "regularClaimHRList",
  regularClaimExeList: "regularClaimExeList",
  regularClaimAccList: "regularClaimAccList",

  claimBackofficeList: "claimBackofficeList",
  claimExecutiveList: "claimExecutiveList",
  claimManagerList: "claimManagerList",
  claimManagerListMain: "claimManagerListMain",
  getClaimBackofficeList: "getClaimBackofficeList",
  getClaimDetailsList: "getClaimDetailsList",
  approveClaimIfoods: "approveClaimIfoods",
  approveClaimBackoffice: "approveClaimBackoffice",
  approveClaimRegular: "approveClaimRegular",
  rejectRegularClaim: "rejectRegularClaim",
  verifyClaim: "verifyClaim",
  rejectClaimIfoods: "rejectClaimIfoods",
  saveClaimMaster: "saveClaimMaster",
  updateClaimMaster: "updateClaimMaster",
  claimReport: "claimReport",
  claimExpenseReport: "claimExpenseReport",
  expenseDetailsShow: "expenseDetailsShow",
  visitInfoDetails: "visitInfoDetails",
  claimApprovedAmtUpdate: "claimApprovedAmtUpdate",
  claimUpdatePercentage: "claimUpdatePercentage",

  companyMaster: "companyMaster",
  saveCompanyMaster: "saveCompanyMaster",
  updateCompanyMaster: "updateCompanyMaster",
  deleteCompanyMaster: "deleteCompanyMaster",
  getEditCompanyMaster: 'getEditCompanyMaster',

  competitorMaster: "competitorMaster",
  saveCompetitorMaster: "saveCompetitorMaster",
  updateCompetitorMaster: "updateCompetitorMaster",
  deleteCompetitorMaster: "deleteCompetitorMaster",
  getEditCompetitorMaster: 'getEditCompetitorMaster',

  competitorOffers: "competitorOffers",
  saveCompetitorOffers: "saveCompetitorOffers",
  updateCompetitorOffers: "updateCompetitorOffers",
  deleteCompetitorOffers: "deleteCompetitorOffers",
  getEditCompetitorOffers: 'getEditCompetitorOffers',

  cityMaster: "cityMaster",
  cityListByDistrict: (district) => `cityListByDistrict/${district}`,
  saveCityMaster: 'saveCityMaster',
  updateCityMaster: 'updateCityMaster',
  deleteCityMaster: 'deleteCityMaster',

  divisionMaster: "divisionMaster",
  saveDivisionMaster: "saveDivisionMaster",
  updateDivisionMaster: "updateDivisionMaster",
  deleteDivisionMaster: "deleteDivisionMaster",
  getEditDivisionMaster: 'getEditDivisionMaster',

  dropdownMaster: "dropdownMaster",
  saveDropdownMaster: "saveDropdownMaster",
  updateDropdownMaster: "updateDropdownMaster",
  deleteDropdownMaster: "deleteDropdownMaster",
  getEditDropdownMaster: 'getEditDropdownMaster',
  dropdownListByDropdown: 'dropdownListByDropdown',

  dropdownlistMaster: "dropdownlistMaster",
  saveDropdownlistMaster: "saveDropdownlistMaster",
  updateDropdownlistMaster: "updateDropdownlistMaster",
  deleteDropdownlistMaster: "deleteDropdownlistMaster",
  getEditDropdownlistMaster: 'getEditDropdownlistMaster',

  energypriceMaster: "energypriceMaster",
  saveEnergyPriceMaster: "saveEnergyPriceMaster",
  updateEnergyPriceMaster: "updateEnergyPriceMaster",
  deleteEnergyPriceMaster: "deleteEnergyPriceMaster",
  getEditEnergyPriceMaster: 'getEditEnergyPriceMaster',

  expenseCategory: 'expenseCategory',
  expenseType: 'expenseType',
  cityType: 'cityType',
  stayType: 'stayType',

  energytypeMaster: "energytypeMaster",
  saveEnergyTypeMaster: "saveEnergyTypeMaster",
  updateEnergyTypeMaster: "updateEnergyTypeMaster",
  deleteEnergyTypeMaster: "deleteEnergyTypeMaster",
  getEditEnergyTypeMaster: 'getEditEnergyTypeMaster',

  countryMaster: "countryMaster",
  saveCountryMaster: 'saveCountryMaster',
  updateCountryMaster: 'updateCountryMaster',
  deleteCountryMaster: 'deleteCountryMaster',

  stateMaster: "stateMaster",
  stateListByZone: (zone) => `stateListByZone/${zone}`,
  saveStateMaster: 'saveStateMaster',
  updateStateMaster: 'updateStateMaster',
  deleteStateMaster: 'deleteStateMaster',

  districtMaster: "districtMaster",
  districtListByState: (stateId) => `districtListByState/${stateId}`,
  districtListByUser: (userId) => `districtListByUser/${userId}`,
  districtListBySubzone: (subzone) => `districtListBySubzone/${subzone}`,
  saveDistrictMaster: 'saveDistrictMaster',
  updateDistrictMaster: 'updateDistrictMaster',
  deleteDistrictMaster: 'deleteDistrictMaster',

  categoryMaster: "categoryMaster",
  saveCategoryMaster: 'saveCategoryMaster',
  categoryListByBrand: 'categoryListByBrand',
  updateCategoryMaster: 'updateCategoryMaster',
  deleteCategoryMaster: 'deleteCategoryMaster',
  getEditCategoryMaster: 'getEditCategoryMaster',

  departmentMaster: "departmentMaster",
  departmentList: "departmentList",
  saveDepartmentMaster: 'saveDepartmentMaster',
  updateDepartmentMaster: 'updateDepartmentMaster',
  deleteDepartmentMaster: 'deleteDepartmentMaster',
  getEditDepartmentMaster: 'getEditDepartmentMaster',
  departmentListByDivision: (division) => `departmentList/${division}`,

  designationMaster: "designationMaster",
  designationList: "designationList",
  saveDesignationMaster: 'saveDesignationMaster',
  updateDesignationMaster: 'updateDesignationMaster',
  deleteDesignationMaster: 'deleteDesignationMaster',
  getEditDesignationMaster: 'getEditDesignationMaster',
  designationListByDepartment: (department) => `designationList/${department}`,


  outletMaster: "outletMaster",
  saveOutletMaster: 'saveOutletMaster',
  updateOutletMaster: 'updateOutletMaster',
  deleteOutletMaster: 'deleteOutletMaster',
  getEditOutletMaster: 'getEditOutletMaster',
  outletBySubzone: (subzone) => `outletBySubzone/${subzone}`,

  menuMaster: "menuMaster",
  deleteMenuMaster: 'deleteMenuMaster',

  materialMaster: "materialMaster",
  getMaterialDataFromSap: "getMaterialDataFromSap",
  saveMaterialMaster: "saveMaterialMaster",
  updateMaterialMaster: "updateMaterialMaster",
  materialDashboard: "materialDashboard",
  deleteMaterialMaster: "deleteMaterialMaster",
  getEditMaterialMaster: "getEditMaterialMaster",

  menuList: "menuList",
  menuListForAccess: "menuListForAccess",
  deleteMenuListMaster: 'deleteMenuListMaster',

  menuAccess: "menuAccess",
  getEditMenuAccess: "getEditMenuAccess",
  saveMenuAccess: "saveMenuAccess",
  updateMenuAccess: "updateMenuAccess",
  deleteMenuAccess: "deleteMenuAccess",

  plantMaster: "plantMaster",
  plantList: "plantList",
  savePlantMaster: 'savePlantMaster',
  updatePlantMaster: 'updatePlantMaster',
  deletePlantMaster: 'deletePlantMaster',
  getEditPlantMaster: 'getEditPlantMaster',
  plantListByDivision: (division) => `plantList/${division}`,

  productMaster: "productMaster",
  productListByCategory: 'productListByCategory',
  saveProductMaster: 'saveProductMaster',
  updateProductMaster: 'updateProductMaster',
  deleteProductMaster: 'deleteProductMaster',
  getEditProductMaster: 'getEditProductMaster',

  prospectMaster: "prospectMaster",
  saveProspectMaster: 'saveProspectMaster',
  prospectApproval: 'prospectApproval',
  updateProspectMaster: 'updateProspectMaster',
  pendingProspectMaster: 'pendingProspectMaster',
  deleteProspectMaster: 'deleteProspectMaster',
  getEditProspectMaster: 'getEditProspectMaster',
  prospectReport: 'prospectReport',

  prospectValidation: 'prospectValidation',
  getEditProspectApprove: 'getEditProspectApprove',

  shiftMaster: "shiftMaster",
  saveShiftMaster: 'saveShiftMaster',
  updateShiftMaster: 'updateShiftMaster',
  deleteShiftMaster: 'deleteShiftMaster',
  getEditShiftMaster: 'getEditShiftMaster',

  gradeMaster: "gradeMaster",
  gradeMasterOption: "gradeMasterOption",
  saveGradeMaster: 'saveGradeMaster',
  updateGradeMaster: 'updateGradeMaster',
  deleteGradeMaster: 'deleteGradeMaster',
  getEditGradeMaster: 'getEditGradeMaster',

  gradeList: "gradeList",
  gradeListOption: "gradeListOption",
  saveGradeList: 'saveGradeList',
  updateGradeList: 'updateGradeList',
  deleteGradeList: 'deleteGradeList',
  getEditGradeList: 'getEditGradeList',

  zoneMaster: "zoneMaster",
  accessibleZoneMaster: "accessibleZoneMaster",
  zoneByDivision: "zoneByDivision",
  saveZoneMaster: 'saveZoneMaster',
  updateZoneMaster: 'updateZoneMaster',
  deleteZoneMaster: 'deleteZoneMaster',

  subzoneMaster: "subzoneMaster",
  savesubzoneMaster: 'savesubzoneMaster',
  updatesubzoneMaster: 'updatesubzoneMaster',
  deletesubzoneMaster: 'deletesubzoneMaster',

  roleMaster: "roleMaster",
  saveRoleMaster: 'saveRoleMaster',
  updateRoleMaster: 'updateRoleMaster',
  deleteRoleMaster: 'deleteRoleMaster ',

  venueMaster: "venueMaster",
  saveVenueMaster: "saveVenueMaster",
  updateVenueMaster: "updateVenueMaster",
  getEditVenueMaster: 'getEditVenueMaster',

  pjpStore: 'pjpStore',
  pjpUpdate: 'pjpUpdate',
  pjpDelete: 'pjpDelete',
  pjpMaster: 'pjpMaster',
  getEditPjpMaster: 'getEditPjpMaster',

  primaryCustomer: "primaryCustomer",
  primaryCustomerOption: "primaryCustomerOption",
  getPrimeCustDataFromSap: "getPrimeCustDataFromSap",
  primeCustListBySubzone: (subzone) => `primeCustListBySubzone/${subzone}`,
  primeCustListByCity: (city) => `primeCustListByCity/${city}`,
  savePrimaryCustomerMaster: 'savePrimaryCustomerMaster',
  updatePrimaryCustomerMaster: 'updatePrimaryCustomerMaster',
  deletePrimaryCustomerMaster: 'deletePrimaryCustomerMaster',
  getEditPrimaryCustomerMaster: 'getEditPrimaryCustomerMaster',
  primaryCustomerReport: 'primaryCustomerReport',

  primaryCustomerVisitReport: 'primaryCustomerVisitReport',
  secondaryCustomerVisitReport: 'secondaryCustomerVisitReport',
  secondaryOrderReport: 'secondaryOrderReport',

  secondaryCustomerMaster: "secondaryCustomerMaster",
  saveSecCustomerMaster: "saveSecCustomerMaster",
  updateSecCustomerMaster: "updateSecCustomerMaster",
  deleteSecondaryCustomerMaster: "deleteSecondaryCustomerMaster",
  getEditSecCustomerMaster: "getEditSecCustomerMaster",
  secondaryCustomerReport: "secondaryCustomerReport",

  getEditCountryMaster: 'getEditCountryMaster',
  getEditStateMaster: 'getEditStateMaster',
  getEditZoneMaster: 'getEditZoneMaster',
  getEditSubzoneMaster: 'getEditSubzoneMaster',
  getEditMenuMaster: 'getEditMenuMaster',
  getEditMenuListMaster: 'getEditMenuListMaster',
  getEditRoleMaster: 'getEditRoleMaster',

  ifoodsPlanApproval: 'ifoodsPlanApproval',
  getEditBoPlanApprove: 'getEditBoPlanApprove',
  approvePlan: 'approvePlan',
  rejectPlan: 'rejectPlan',

  getPlanApprManager: 'getPlanApprManager',
  approvePlanManager: 'approvePlanManager',
  rejectPlanManager: 'rejectPlanManager',
  getEditManagerPlanDevApprove: 'getEditManagerPlanDevApprove',

  getPlanDeviaApprManager: 'getPlanDeviaApprManager',
  deviationApprovalManager: 'deviationApprovalManager',
  deviationRejectManager: 'deviationApprovalManager',

  ifoodsPlanDevData: 'ifoodsPlanDevData',
  getEditBoPlanDevApprove: 'getEditBoPlanDevApprove',
  ifoodsPlanDevApprove: 'ifoodsPlanDevApprove',
  ifoodsPlanDevReject: 'ifoodsPlanDevReject',

  planApplicable: 'planApplicable',
  planCategoryListByDivision: 'planCategoryListByDivision',
  savePlanApplicable: 'savePlanApplicable',
  updatePlanApplicable: 'updatePlanApplicable',
  deletePlanApplicable: 'deletePlanApplicable',
  getEditPlanApplicable: 'getEditPlanApplicable',

  attendanceReport: 'attendanceReport',
  travelReport: 'travelReport',
  travelClaimReport: 'travelClaimReport',
  // planReport : 'planReport',
  planDetailsReport: 'planDetailsReport',
  primaryOrderListReport: 'primaryOrderListReport',
  primaryOrderDetails: 'primaryOrderDetails',
  appTrackReport: 'appTrackReport',
  marketPromotionReport: 'marketPromotionReport',
  outletVisitReport: 'outletVisitReport',
  productOfferReport: 'productOfferReport',
  competitorReport: 'competitorReport',
  expApplicableAmount: 'expApplicableAmount',
  getSharingUserList: 'getSharingUserList',
  getAllowTravelKm: 'getAllowTravelKm',
  userMapReport: 'userMapReport',
  pjpReport: 'pjpReport',
  appTransportMode: 'appTransportMode',

  glMaster: "glMaster",
  saveGlMaster: "saveGlMaster",
  updateGlMaster: "updateGlMaster",
  deleteGlMaster: "deleteGlMaster",
  getEditGlMaster: 'getEditGlMaster',

  foodsCompetitorMaster: "foodsCompetitorMaster",
  saveFoodsCompetitorMaster: "saveFoodsCompetitorMaster",
  updateFoodsCompetitorMaster: "updateFoodsCompetitorMaster",
  deleteFoodsCompetitorMaster: "deleteFoodsCompetitorMaster",
  getEditFoodsCompetitorMaster: 'getEditFoodsCompetitorMaster',

  notificationSettingsList: "notificationSettingsList",
  saveNotificationSettingsList: "saveNotificationSettingsList",
  deleteNotificationSettingsList: "deleteNotificationSettingsList",
  updateNotificationSettingsList: "updateNotificationSettingsList",

  commonNotificationList: "commonNotificationList",
  saveCommonNotificationList: "saveCommonNotificationList",
  deleteCommonNotificationList: "deleteCommonNotificationList",
  updateCommonNotificationList: "updateCommonNotificationList",

  getPrimaryOrderCount: 'getPrimaryOrderCount',

  getWebNotificationCount: 'getWebNotificationCount',

  primeCustMappingData: 'primeCustMappingData',
  fetchPrimeCustMappingData: 'fetchPrimeCustMappingData',

  secondaryCustomerList: 'secondaryCustomerList',
  secondaryCustomerSinApprove: 'secondaryCustomerSinApprove',
  secondaryCustomerMulApprove: 'secondaryCustomerMulApprove',
  getEditSecondaryCustomer: 'getEditSecondaryCustomer',
  secondaryByDistrict: (city) => `secondaryByDistrict/${city}`,

  claimLocationCategory: "claimLocationCategory",
  saveClaimLocationCategory: "saveClaimLocationCategory",
  updateClaimLocationCategory: "updateClaimLocationCategory",
  deleteClaimLocationCategory: "deleteClaimLocationCategory",
  getEditClaimLocationCategory: 'getEditClaimLocationCategory',

  claimFrequencyList: "claimFrequencyList",
  saveClaimFrequency: "saveClaimFrequency",
  updateClaimFrequency: "updateClaimFrequency",
  deleteClaimFrequency: "deleteClaimFrequency",
  getEditClaimFrequency: 'getEditClaimFrequency',
  getClaimEmployeeExpenses: "getClaimEmployeeExpenses",
  approvalDesignation: "approvalDesignation",

  expenselimitMaster: "expenselimitMaster",
  saveExpenseLimitMaster: "saveExpenseLimitMaster",
  updateExpenseLimitMaster: "updateExpenseLimitMaster",
  deleteExpenseLimitMaster: "deleteExpenseLimitMaster",
  getEditExpenseLimitMaster: 'getEditExpenseLimitMaster',

  frequencyTypeMaster: "frequencyTypeMaster",
  saveFrequencyTypeMaster: "saveFrequencyTypeMaster",
  updateFrequencyTypeMaster: "updateFrequencyTypeMaster",
  deleteFrequencyTypeMaster: "deleteFrequencyTypeMaster",
  getEditFrequencyTypeMaster: 'getEditFrequencyTypeMaster',

  targetFileUpload: 'targetFileUpload',
  claimStatusLog: 'claimStatusLog',
  claimLog: 'claimLog',
  claimExpenseLog: 'claimExpenseLog',

  dashboardSlider: 'dashboardSlider',
  saveDashboardSlider: 'saveDashboardSlider',
  updateDashboardSlider: 'updateDashboardSlider',
  deleteDashboardSlider: 'deleteDashboardSlider',
  getEditDashboardSlider: 'getEditDashboardSlider',

  //Sooji QR Bag//

  newBagRequest: "newBagRequest",
  saveNewBagRequest: "saveNewBagRequest",
  updateNewBagRequest: "updateNewBagRequest",
  deleteNewBagRequest: "deleteNewBagRequest",
  getEditNewBagRequest: 'getEditNewBagRequest',

  bagRequest: "bagRequest",
  saveBagRequest: "saveBagRequest",
  updateBagRequest: "updateBagRequest",
  deleteBagRequest: "deleteBagRequest",
  getEditBagRequest: 'getEditBagRequest',

  bagIssue: "bagIssue",
  saveBagIssue: "saveBagIssue",
  updateBagIssue: "updateBagIssue",
  deleteBagIssue: "deleteBagIssue",
  getEditBagIssue: 'getEditBagIssue',

  storeNewBagRequest: "storeNewBagRequest",
  saveStoreNewBagRequest: "saveStoreNewBagRequest",
  updateStoreNewBagRequest: "updateStoreNewBagRequest",
  deleteStoreNewBagRequest: "deleteStoreNewBagRequest",
  getEditStoreNewBagRequest: 'getEditStoreNewBagRequest',

  bagReport: "bagReport",
  saveBagReport: "saveBagReport",
  updateBagReport: "updateBagReport",
  deleteBagReport: "deleteBagReport",
  getEditBagReport: "getEditBagReport",

  fillBag: "fillBag",
  saveFillBag: "saveFillBag",
  updateFillBag: "updateFillBag",
  deleteFillBag: "deleteFillBag",
  getEditFillBag: "getEditFillBag",
  scrapFillBag: "scrapFillBag",

  qcRelease: "qcRelease",
  qcReleaseExceeded: "qcReleaseExceeded",
  saveQCRelease: "saveQCRelease",
  updateQCRelease: "updateQCRelease",
  updateQCReleaseExceeded: "updateQCReleaseExceeded",
  deleteQCRelease: "deleteQCRelease",
  getEditQCRelease: "getEditQCRelease",
  getQRCodeDetails: "getQRCodeDetails",

  roastingProcess: "roastingProcess",
  roastingProcessExceeded: "roastingProcessExceeded",
  saveRoastingProcess: "saveRoastingProcess",
  updateRoastingProcess: "updateRoastingProcess",
  updateRoastingProcessExceeded: "updateRoastingProcessExceeded",
  deleteRoastingProcess: "deleteRoastingProcess",
  getEditRoastingProcess: "getEditRoastingProcess",

  fumigationProcess: "fumigationProcess",
  fumigationProcessExceeded: "fumigationProcessExceeded",
  saveFumigationProcess: "saveFumigationProcess",
  updateFumigationProcess: "updateFumigationProcess",
  updateFumigationProcessExceeded: "updateFumigationProcessExceeded",
  deleteFumigationProcess: "deleteFumigationProcess",
  getEditFumigationProcess: "getEditFumigationProcess",

  qrTransReport: "qrTransReport",
  saveQRTransReport: "saveQRTransReport",
  updateQRTransReport: "updateQRTransReport",
  deleteQRTransReport: "deleteQRTransReport",
  getEditQRTransReport: "getEditQRTransReport",

  /* Scheme Creation */
  schemeCreationShow: 'schemeCreationShow',
  customerLogs: 'customerLogs',
  saveSchemeCreation: "saveSchemeCreation",
  updateSchemeCreation: "updateSchemeCreation",
  deleteSchemeCreation: "deleteSchemeCreation",
  getEditSchemeCreation: "getEditSchemeCreation",
  approvalDesignation: "approvalDesignation",
  

  schemeCreationApproval: "schemeCreationApproval",
  saveSchemeCreationApproval: "saveSchemeCreationApproval",
  updateSchemeCreationApproval: "updateSchemeCreationApproval",
  deleteSchemeCreationApproval: "deleteSchemeCreationApproval",
  getEditSchemeCreationApproval: "getEditSchemeCreationApproval",
  getSchemeCreationApproved: "getSchemeCreationApproved",

  schemeCreationApprovalCH: "schemeCreationApprovalCH",
  saveSchemeCreationApprovalCH: "saveSchemeCreationApprovalCH",
  updateSchemeCreationApprovalCH: "updateSchemeCreationApprovalCH",
  deleteSchemeCreationApprovalCH: "deleteSchemeCreationApprovalCH",
  getEditSchemeCreationApprovalCH: "getEditSchemeCreationApprovalCH",
  getSchemeCreationApprovedCH: "getSchemeCreationApprovedCH",

  schemeCreationApprovalBH: "schemeCreationApprovalBH",
  saveSchemeCreationApprovalBH: "saveSchemeCreationApprovalBH",
  updateSchemeCreationApprovalBH: "updateSchemeCreationApprovalBH",
  deleteSchemeCreationApprovalBH: "deleteSchemeCreationApprovalBH",
  getEditSchemeCreationApprovalBH: "getEditSchemeCreationApprovalBH",
  getSchemeCreationApprovedBH: "getSchemeCreationApprovedBH",

  /* Schemes List View */
  schemesListMaster: "schemesListMaster",
  deleteSchemesListMaster: "deleteSchemesListMaster",
  getEditSchemesListMaster: "getEditSchemesListMaster",
  updateSchemesListMaster: "updateSchemesListMaster",
  rejectSchemesListMaster: "rejectSchemesListMaster",
  schemesListMasterAll: "schemesListMasterAll",
  getEditSchemesListMasterAll: "getEditSchemesListMasterAll",

  schemesListTeamWiseMaster: "schemesListTeamWiseMaster",
  getEditSchemesListTeamWiseMaster: "getEditSchemesListTeamWiseMaster",

  /* Schemes Non Eligible List View */
  schemesNonEligibleListMaster: "schemesNonEligibleListMaster",
  getEditSchemesNonEligibleListMaster: "getEditSchemesNonEligibleListMaster",
  updateSchemesNonEligibleListMaster: "updateSchemesNonEligibleListMaster",

  /* Schemes Master */
  schemeMaster: "schemeMaster",
  saveSchemeMaster: "saveSchemeMaster",
  updateSchemeMaster: "updateMaterialMaster",
  schemeDashboard: "schemeDashboard",
  deleteSchemeMaster: "deleteSchemeMaster",
  getEditSchemeMaster: "getEditSchemeMaster",
  getSchemeByGroupId: "getSchemeByGroupId",

  schemeGMApproval: "schemeGMapproval",
  saveSchemeGMapproval: "saveSchemeGMapproval",
  updateSchemeGMapproval: "updateSchemeGMapproval",
  rejectSchemeGMapproval: "rejectSchemeGMapproval",
  rejectSchemeGMapprovalMaster: "rejectSchemeGMapprovalMaster",
  individualRejectSchemeGMapproval: "individualRejectSchemeGMapproval",
  deleteSchemeGMapproval: "deleteSchemeGMapproval",
  getEditSchemeGMApproval: "getEditSchemeGMapproval",
  getSchemeGMapproved: "getSchemeGMapproved",
  schemeGMRejected: "schemeGMRejected",

  schemeCHapproval: "schemeCHapproval",
  saveSchemeCHapproval: "saveSchemeCHapproval",
  updateSchemeCHapproval: "updateSchemeCHapproval",
  rejectSchemeCHapproval: "rejectSchemeCHapproval",
  rejectSchemeCHapprovalMaster: "rejectSchemeCHapprovalMaster",
  individualRejectSchemeCHapproval: "individualRejectSchemeCHapproval",
  deleteSchemeCHapproval: "deleteSchemeCHapproval",
  getEditSchemeCHapproval: "getEditSchemeCHapproval",
  getSchemeCHapproved: "getSchemeCHapproved",
  schemeCHRejected: "schemeCHRejected",
  schemeRejectedCustomersList: "schemeRejectedCustomersList",
  schemeRejectedCustomersDetail: "schemeRejectedCustomersDetail",
  resubmitRejectedCustomer: "resubmitRejectedCustomer",

  schemeAdminEdit: "schemeAdminEdit",
  saveSchemeAdminEdit: "saveSchemeAdminEdit",
  updateSchemeAdminEdit: "updateSchemeAdminEdit",
  rejectSchemeAdminEdit: "rejectSchemeAdminEdit",
  deleteSchemeAdminEdit: "deleteSchemeAdminEdit",
  getEditSchemeAdminEdit: "getEditSchemeAdminEdit",
  getSchemeAdminEditApproved: "getSchemeAdminEditApproved",

  schemeBHapproval: "schemeBHapproval",
  saveSchemeBHapproval: "saveSchemeBHapproval",
  updateSchemeBHapproval: "updateSchemeBHapproval",
  rejectSchemeBHapproval: "rejectSchemeBHapproval",
  rejectSchemeBHapprovalMaster: "rejectSchemeBHapprovalMaster",
  individualRejectSchemeBHapproval: "individualRejectSchemeBHapproval",
  deleteSchemeBHapproval: "deleteSchemeBHapproval",
  getEditSchemeBHapproval: "getEditSchemeBHapproval",
  getSchemeBHapproved: "getSchemeBHapproved",
  schemeBHRejected: "schemeBHRejected",

  schemeAHcreditnoteApproval: "schemeAHCreditNoteapproval",
  saveSchemeAHCreditNoteApproval: "saveSchemeAHCreditNoteapproval",
  updateSchemeAHCreditNoteApproval: "updateSchemeAHCreditNoteapproval",
  deleteSchemeAHCreditNoteApproval: "deleteSchemeAHCreditNoteapproval",
  getEditSchemeAHcreditnoteApproval: "getEditSchemeAHcreditnoteApproval",
  getSchemeAHCreditNoteApproved: "getSchemeAHCreditNoteapproved",
  rejectSchemeAHCreditNoteApproval: "rejectSchemeAHCreditNoteapproval",
  rejectSchemeAHApprovalMaster: "rejectSchemeAHApprovalMaster",
  individualRejectSchemeAHApproval: "individualRejectSchemeAHApproval",

  schemeCreditnoteReport: " schemeCreditnoteReport",
  getEditSchemeCreditnoteReport: "getEditSchemeCreditnoteReport",
  getCreditNotePdf: "getCreditNotePdf",

  schemeCostCenterMaster: "schemeCostCenterMaster",
  saveSchemeCostCenterMaster: "saveSchemeCostCenterMaster",
  updateSchemeCostCenterMaster: "updateSchemeCostCenterMaster",

  schemeProductCostCenterMapping: "schemeProductCostCenterMapping",
  saveSchemeProductCostCenterMapping: "saveSchemeProductCostCenterMapping",
  updateSchemeProductCostCenterMapping: "updateSchemeProductCostCenterMapping",
  schemeSapSync: "schemeSapSync",
  schemeCostCenterActualReport: "schemeCostCenterActualReport",

  /* Pest Control */
  pestControlDailyEntryList: "pestControlDailyEntryList",
  savePestControlDailyEntry: "savePestControlDailyEntry",
  getPestControlDailyEntry: "getPestControlDailyEntry",
  deletePestControlDailyEntry: "deletePestControlDailyEntry",

  /* Rodent Box Location Master */
  rodentBoxLocationMaster: "rodentBoxLocationMaster",
  saveRodentBoxLocationMaster: "saveRodentBoxLocationMaster",
  getRodentBoxLocationMaster: "getRodentBoxLocationMaster",
  updateRodentBoxLocationMaster: "updateRodentBoxLocationMaster",
  deleteRodentBoxLocationMaster: "deleteRodentBoxLocationMaster",

  /* Location Trap Station Mapping */
  locationTrapStationMapping: "locationTrapStationMapping",
  locationTrapStationMappedNumbers: "locationTrapStationMappedNumbers",
  saveLocationTrapStationMapping: "saveLocationTrapStationMapping",
  getLocationTrapStationMapping: "getLocationTrapStationMapping",
  updateLocationTrapStationMapping: "updateLocationTrapStationMapping",
  deleteLocationTrapStationMapping: "deleteLocationTrapStationMapping",

  /* Rodent QR Code Mapping */
  rodentQRCodeMapping: "rodentQRCodeMapping",
  rodentQRCodeAvailableMappings: "rodentQRCodeAvailableMappings",
  rodentQRCodeAvailableQRCodes: "rodentQRCodeAvailableQRCodes",
  saveRodentQRCodeMapping: "saveRodentQRCodeMapping",
  getRodentQRCodeMapping: "getRodentQRCodeMapping",
  updateRodentQRCodeMapping: "updateRodentQRCodeMapping",
  deleteRodentQRCodeMapping: "deleteRodentQRCodeMapping",

  /* Rodent QR Code Master */
  rodentQRCode: "rodentQRCode",
  rodentQRCodeNextNumber: "rodentQRCodeNextNumber",
  saveRodentQRCode: "saveRodentQRCode",
  batchSaveRodentQRCode: "batchSaveRodentQRCode",
  validateScannedRodentQRCode: "validateScannedRodentQRCode",
  getRodentQRCode: "getRodentQRCode",
  updateRodentQRCode: "updateRodentQRCode",
  deleteRodentQRCode: "deleteRodentQRCode",
});
